import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { EmployeeServiceService } from './service/employee-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from 'src/app/login/service-authen/authentication.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Employee } from './model/model'

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EmployeeComponent implements OnInit {
  // displayedColumns: string[] = ['no', 'username', 'firstname', 'lastname', 'hospitalname', 'phone', 'email', 'status', 'action'];
  displayedColumns: string[] = ['select', 'no', 'username', 'firstname', 'lastname', 'hospitalname', 'email', 'role', 'action'];
  dataSource;
  selection = new SelectionModel<Employee>(true, []);
  seleted: any = [];
  disble_user: string;
  button_All: boolean = false
  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private employee: EmployeeServiceService,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.getEmployee()
    this.onDisbles()
  }

  getEmployee() {
    this.employee.getEmployeeAll().subscribe(users => {
      // console.log(users['result']);
      this.dataSource = new MatTableDataSource<Employee>(users['result'])
      this.dataSource.paginator = this.paginator;
    })
  }

  onDisbles() {
    if (this.authenticationService.getRole() == 'superadmin' || this.authenticationService.getRole() == 'admin') {
      this.disble_user = this.authenticationService.getUser();
      // console.log(this.disble_user);
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private findStartEndIndices(): { startIndex: number, endIndex: number } {
    if (this.dataSource) {
      const pageIndex = this.dataSource.paginator.pageIndex;
      const pageSize = this.dataSource.paginator.pageSize;
      const total = this.dataSource.paginator.length;
      const startIndex = pageIndex * pageSize;
      const endIndex = (startIndex + pageSize) > total ? total : startIndex + pageSize;
      return { startIndex: startIndex, endIndex: endIndex };
    }
  }

  isAllSelected() {
    const page: { startIndex: number, endIndex: number } = this.findStartEndIndices();
    if (this.dataSource) {
      const sortedData = this.dataSource._orderData(this.dataSource.data);
      const numSelected = sortedData.slice(page.startIndex, page.endIndex)
        .filter(row => this.selection.isSelected(row)).length;
      return numSelected === (page.endIndex - page.startIndex);
    }
  }

  isAtLeaseOneSelected() {
    const page: { startIndex: number, endIndex: number } =
      this.findStartEndIndices();
    if (this.dataSource) {
      const sortedData = this.dataSource._orderData(this.dataSource.data);
      const numSelected = sortedData.slice(page.startIndex, page.endIndex)
        .filter(row => this.selection.isSelected(row)).length;
      return numSelected > 0;
    }
  }


  masterToggle() {
    const page: { startIndex: number, endIndex: number } = this.findStartEndIndices();

    const sortedData = this.dataSource._orderData(this.dataSource.data);

    if (this.isAllSelected()) {
      sortedData.slice(page.startIndex, page.endIndex).forEach(row => {
        this.selection.deselect(row);
        // this.button_All = true
      });
    }

    else {
      sortedData.slice(page.startIndex, page.endIndex).forEach(row => {
        this.selection.select(row);
        // this.button_All = false
      });
    }
  }


  rowToggle(row) {
    this.selection.toggle(row);
    row.selected = !row.selected;
    if (!row.selected) {
      this.button_All = true
    } else {
      this.button_All = false
    }
    // console.log(!row.selected)
  }

  dialog_addUser() {
    const dialogRef = this.dialog.open(dialog_add_employee, {
      width: '60%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getEmployee()
    })
  }

  editUser(data: any) {
    localStorage.setItem('dataEdit', JSON.stringify(data))
    // console.log(data);
    const dialogRef = this.dialog.open(dialog_edit_employee, {
      width: '60%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getEmployee()
      localStorage.removeItem('dataEdit')
    })
  }

  // Dialog Delete
  dialog_deleteUser(id: any): void {
    localStorage.setItem('id', id)
    const dialogRef = this.dialog.open(dialog_delete_employee, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getEmployee()
      localStorage.removeItem('id')
    })
  }

  // Dialog Delete
  Dialog_Delete(): void {
    // console.log(this.selection.selected.length);
    // if(this.selection.selected != []){
    this.selection.selected.forEach(item => {
      this.seleted.push(item['account_id'])
      localStorage.setItem('seleted', JSON.stringify(this.seleted))
    });
    if (this.selection.selected.length != 0) {
      const dialogRef = this.dialog.open(dialog_select_delete, {
        width: '710px',
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.getEmployee()
        this.selection.clear();
        localStorage.removeItem('seleted')
        this.seleted = []
        // this.toggle.setValue(false)
        // this.haveValue = true
      })
    } else {
      this._snackBar.open('Please select user!.', 'Done', {
        duration: 5000,
      });
    }
  }

  dialog_forget_password(id: any) {
    localStorage.setItem('id_forget_password', JSON.stringify(id))
    // console.log(data);
    const dialogRef = this.dialog.open(dialog_forget_password, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getEmployee()
      localStorage.removeItem('id_forget_password')
    })
  }
}

// export interface PeriodicElement {
//   name: string;
//   position: number;
//   weight: number;
//   symbol: string;
// }

// const ELEMENT_DATA: PeriodicElement[] = [
//   {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
//   {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
//   {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
//   {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
//   {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
//   {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
//   {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
//   {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
//   {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
//   {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
//   {position: 11, name: 'Sodium', weight: 22.9897, symbol: 'Na'},
//   {position: 12, name: 'Magnesium', weight: 24.305, symbol: 'Mg'},
//   {position: 13, name: 'Aluminum', weight: 26.9815, symbol: 'Al'},
//   {position: 14, name: 'Silicon', weight: 28.0855, symbol: 'Si'},
//   {position: 15, name: 'Phosphorus', weight: 30.9738, symbol: 'P'},
//   {position: 16, name: 'Sulfur', weight: 32.065, symbol: 'S'},
//   {position: 17, name: 'Chlorine', weight: 35.453, symbol: 'Cl'},
//   {position: 18, name: 'Argon', weight: 39.948, symbol: 'Ar'},
//   {position: 19, name: 'Potassium', weight: 39.0983, symbol: 'K'},
//   {position: 20, name: 'Calcium', weight: 40.078, symbol: 'Ca'},
// ];

@Component({
  selector: 'dialog_add_employee',
  templateUrl: 'dialog-add-employee.html',
  styleUrls: ['employee.component.scss']
})
export class dialog_add_employee implements OnInit {
  // ceate form add
  formAdd: FormGroup;
  hospitalAPI = `${environment.apiUrl}/hospitals`;
  createUserApi = `${environment.apiUrl}/users/bypass`;
  hospitals: any;
  roleFlag: string;
  // hospitals: string[] = ['โรงพยาบาลเทพหรั่ง','โรงพยาบาลเฮียหมู','โรงพยาบาลInet','โรงพยาบาลAI'];
  filteredOptions: Observable<string[]>;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_add_employee>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar,
    private authenticationService: AuthenticationService
  ) {
    this.formAddUser()
  }

  ngOnInit() {
    this.getHospital()
    this.checkRole()
    this.formAdd.get('password').disable()
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.hospitals.filter(option => option.toLowerCase().includes(filterValue));
  }

  getHospital() {
    this.http.get(this.hospitalAPI, this.httpOptions).subscribe(hospitals => {
      // console.log(hospitals['message']);
      this.hospitals = hospitals['message']
      this.filteredOptions = this.formAdd.get('hospital_name_th').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    })
  }

  checkRole() {
    this.roleFlag = this.authenticationService.getRole();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formAddUser() {
    this.formAdd = this.formBuilder.group({
      hospital_name_th: ['', Validators.required],
      // phone: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      name_title: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      username: ['', Validators.required],
      password: [''],
      email: ['', [Validators.email, Validators.required]],
      role: ['', Validators.required]
      // birth: ['', Validators.required]
    })
  }

  addUser() {
    // console.log(this.formAdd.value);
    if (this.formAdd.invalid) return;
    this.http.post(this.createUserApi, this.formAdd.value, this.httpOptions).subscribe(res => {
      // console.log(res);
      this.onNoClick()
      this._snackBar.open('Add user success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err.error.message);
      if (err.error.message == 'duplicate username') {
        this._snackBar.open('duplicate username.', 'Done', {
          duration: 5000,
        });
      } else if (err.error.message) {
        this._snackBar.open(err.error.message, 'Done', {
          duration: 5000,
        });
      }
      else {
        this._snackBar.open('Add user fail!.', 'Done', {
          duration: 5000,
        });
      }
    })
  }

}

@Component({
  selector: 'dialog_edit_employee',
  templateUrl: 'dialog-edit-employee.html',
  styleUrls: ['employee.component.scss']
})
export class dialog_edit_employee implements OnInit {
  data_edit = JSON.parse(localStorage.getItem('dataEdit'))
  // ceate form add
  formEdit: FormGroup;
  hospitalAPI = `${environment.apiUrl}/hospitals`;
  editUserApi = `${environment.apiUrl}/users`;
  hospitals: any;
  // hospitals: string[] = ['โรงพยาบาลเทพหรั่ง', 'โรงพยาบาลเฮียหมู', 'โรงพยาบาลInet', 'โรงพยาบาลAI'];

  roleFlag: string;
  filteredOptions: Observable<string[]>;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_edit_employee>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar,
    private authenticationService: AuthenticationService
  ) {
    this.formEditUser()
  }

  ngOnInit() {
    // console.log(this.data_edit);
    this.setDataEdit()
    this.checkRole()
    this.getHospital()
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.hospitals.filter(option => option.toLowerCase().includes(filterValue));
  }

  getHospital() {
    this.http.get(this.hospitalAPI, this.httpOptions).subscribe(hospitals => {
      // console.log(hospitals['message']);
      this.hospitals = hospitals['message']
      this.filteredOptions = this.formEdit.get('hospital_name_th').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    })
  }

  checkRole() {
    this.roleFlag = this.authenticationService.getRole();
    if (this.roleFlag == "superadmin") {
      this.formEdit.get('hospital_name_th').enable()
    } else {
      this.formEdit.get('hospital_name_th').disable()
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formEditUser() {
    this.formEdit = this.formBuilder.group({
      account_id: [''],
      hospital_name_th: ['', Validators.required],
      // phone: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      name_title: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      username: ['', Validators.required],
      // password: ['', Validators.required],
      email: ['', [Validators.email, Validators.required]],
      role: ['', Validators.required],
      // status: ['', Validators.required]
    })
  }

  setDataEdit() {
    this.formEdit.controls['account_id'].setValue(this.data_edit['account_id'])
    this.formEdit.controls['name_title'].setValue(this.data_edit['name_title'])
    this.formEdit.controls['hospital_name_th'].setValue(this.data_edit['hospital_name'])
    // this.formEdit.controls['phone'].setValue(this.data_edit['phone'])
    this.formEdit.controls['first_name'].setValue(this.data_edit['first_name'])
    this.formEdit.controls['last_name'].setValue(this.data_edit['last_name'])
    this.formEdit.controls['username'].setValue(this.data_edit['username'])
    this.formEdit.controls['email'].setValue(this.data_edit['email'])
    this.formEdit.controls['role'].setValue(this.data_edit['role'])
    // console.log(this.formEdit.value);
  }

  editUser() {
    this.formEdit.get('hospital_name_th').enable()
    // console.log(this.formEdit.value);
    this.http.put(`${this.editUserApi}?account_id=${this.formEdit.value.account_id}`, this.formEdit.value, this.httpOptions).subscribe(res => {
      console.log(res);
      this.onNoClick()
      this._snackBar.open('Edit user success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Edit user fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_delete_employee',
  templateUrl: 'dialog-delete-employee.html',
  styleUrls: ['employee.component.scss']
})
export class dialog_delete_employee implements OnInit {
  data_id = localStorage.getItem('id')
  deleteuserAPI = `${environment.apiUrl}/users?account_id=${this.data_id}`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_delete_employee>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteUser() {
    this.http.delete(this.deleteuserAPI, this.httpOptions).subscribe(data => {
      // console.log('Delete Success', data);
      this.onNoClick()
      this._snackBar.open('Delete user success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Delete user fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_select_delete',
  templateUrl: 'dialog-select-delete.html',
  styleUrls: ['employee.component.scss']
})
export class dialog_select_delete implements OnInit {
  seleted = JSON.parse(localStorage.getItem('seleted'));
  message = "Delete Sussecc!"
  action = "Done"
  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  delUserApi = `${environment.apiUrl}/users/select`;

  constructor(
    public dialogRef: MatDialogRef<dialog_select_delete>,
    private http: HttpClient,
    // private route: Router,
    public _snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  delete_select_employee() {
    // console.log(this.seleted);
    this.http.delete(`${this.delUserApi}?account_id=${this.seleted}`, this.httpOptions).subscribe(data => {
      console.log('Delete Success', data);
      this.seleted = []
      localStorage.removeItem('seleted')
      this._snackBar.open(this.message, this.action, {
        duration: 5000,
      });
      this.onNoClick()
    }, error => {
      // this.seleted = []
      // localStorage.removeItem('seleted')
      this._snackBar.open("Delete fail!", this.action, {
        duration: 5000,
      });
      console.log('Error: ', error.error.message);
    });
  }

}


@Component({
  selector: 'dialog_forget_password',
  templateUrl: 'dialog-forget-password.html',
  styleUrls: ['employee.component.scss']
})
export class dialog_forget_password implements OnInit {
  data_id = JSON.parse(localStorage.getItem('id_forget_password'))
  forgetApi = `${environment.apiUrl}/users/forget`;

  message = "Forget Password Sussecc!"
  action = "Done"

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_forget_password>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  forget_password() {
    this.http.put(`${this.forgetApi}`, {
      account_id: this.data_id
    },
      this.httpOptions).subscribe(data => {
        // console.log('Delete Success', data);
        this._snackBar.open(this.message, this.action, {
          duration: 5000,
        });
        this.onNoClick()
      }, error => {
        this._snackBar.open("Forget Password fail!", this.action, {
          duration: 5000,
        });
        console.log('Error: ', error.error.message);
      });
  }

}
